export default {
  basketVersion: "1.0.6",
};
